module.exports = __webpack_public_path__ + "img/map0.9abe25e8.jpg";